import { getPlainDisplayValue, getSortedValues, getVisibleMetricIndex } from '@libs/NwFeatures';
import { showLog } from '@libs/NwMoment';

import { hasFeatureValue } from '@components/Features/FeatureItemFormUtils';

export const PUBLIC_INLINE_MAX_LENGTH = 8;

export const getItemSpan = (feature, itemFeature) => {
    switch (itemFeature.TypeName.toLowerCase()) {
        case 'conversion':
            if (itemFeature.Name.length > 10) {
                return 2;
            }
            return 1;
        case 'boolean':
            if (itemFeature.Name.length > 10) {
                return 2;
            }
            return 1;
        case 'choice': {
            const choicevalue = getPlainDisplayValue(feature.DisplayValue);
            if (choicevalue.length > 80) {
                return 4;
            }
            if (choicevalue.length > 20) {
                return 2;
            }
            if (itemFeature.Name.length > 10) {
                return 2;
            }
            return 1;
        }
        case 'multichoice':
            return 4;
        default: {
            const text = feature.Value;
            if (text.length > 80) {
                return 4;
            }
            if (text.length > 20) {
                return 2;
            }
            if (itemFeature.Name.length > 10) {
                return 2;
            }
            return 1;
        }
    }
};

/**
 * Copia della feature con il valore pubblico al posto di quello privato, o null se assente.
 * La resa per tipo resta identica: non deve sapere nulla del valore pubblico.
 */
export const getPublicFeatureForDisplay = (feature) => {
    if (!hasFeatureValue(feature.PublicValue)) {
        return null;
    }

    return {
        ...feature,
        Value: feature.PublicValue,
        DisplayValue: feature.PublicDisplayValue,
    };
};

/**
 * La stessa cosa per la main feature del payload `.FT` della lista modelle, dove il valore
 * pubblico sta in PV e il suo display value in PDV.
 */
export const getPublicMainFeature = (mainFeature) => {
    if (!hasFeatureValue(mainFeature.PV)) {
        return null;
    }

    return { ...mainFeature, V: mainFeature.PV, DV: mainFeature.PDV };
};

export const getFeatureDisplayValue = (feature, itemFeature, { featuresIndex, gender, getMetricIndex }) => {
    switch (itemFeature.TypeName.toLowerCase()) {
        case 'conversion': {
            const sortedValues = feature
                ? getSortedValues(feature.DisplayValue, itemFeature.ConversionID, featuresIndex, { gender })
                : [];
            // stessa metrica mostrata da FeatureGroupContent, che può non esserci: qui serve solo la lunghezza
            const selectedValue = sortedValues[getVisibleMetricIndex(sortedValues, getMetricIndex(itemFeature))];
            return selectedValue ? selectedValue.value : '';
        }
        case 'choice':
        case 'multichoice':
            return getPlainDisplayValue(feature.DisplayValue);
        default:
            return feature.Value;
    }
};

export const shouldShowInlinePublicValue = (feature, publicFeature, itemFeature, deps) => {
    if (!publicFeature) {
        return false;
    }

    const privateValue = getFeatureDisplayValue(feature, itemFeature, deps);
    const publicValue = getFeatureDisplayValue(publicFeature, itemFeature, deps);

    return String(privateValue).length + String(publicValue).length <= PUBLIC_INLINE_MAX_LENGTH;
};

export const getHistoryTooltipContent = (feature, getUserName) => {
    let content = '';
    if (feature.DateModified) {
        content += `last updated on: ${showLog(feature.DateModified)}`;
        if (feature.UserModified) {
            content += ` by ${getUserName(feature.UserModified)}`;
        }
    } else {
        content += `added on: ${showLog(feature.DateCreated)}`;
        if (feature.UserCreated) {
            content += ` by ${getUserName(feature.UserCreated)}`;
        }
    }
    return content;
};
